import { render, staticRenderFns } from "./VaultManageView.vue?vue&type=template&id=c9ccb506&scoped=true&"
import script from "./VaultManageView.vue?vue&type=script&lang=ts&"
export * from "./VaultManageView.vue?vue&type=script&lang=ts&"
import style0 from "./VaultManageView.vue?vue&type=style&index=0&id=c9ccb506&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9ccb506",
  null
  
)

export default component.exports